import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@patient-watch/ui/form";
import { Card } from "@patient-watch/ui";
import { Label } from "@patient-watch/ui/label";
import { useFormContext } from "react-hook-form";
import RatingOptions from "./RatingOptions";
import { RichLabel } from "./components/RichLabel";

import type { InputT } from "@patient-watch/types";

interface Props {
    input: InputT;
    name: string;
    label: string;
}

const Rating = ({ input, name, label }: Props) => {
    const { control } = useFormContext();

    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <Card className="flex flex-col gap-2 bg-white/70 p-4">
                        <FormLabel>
                            {input.input_caption && (
                                <span className="block mb-1 font-normal text-muted-foreground text-sm italic">
                                    {input.input_caption}
                                </span>
                            )}
                            <Label>
                                <RichLabel>{label}</RichLabel>
                            </Label>
                            {!input.is_optional && <span className="ml-0.5 text-red-500">*</span>}
                        </FormLabel>
                        {input.input_description && (
                            <FormDescription>
                                <RichLabel>{input.input_description}</RichLabel>
                            </FormDescription>
                        )}
                        <FormControl>
                            <RatingOptions
                                options={input.scale_options || []}
                                orientation={input.orientation || "horizontal"}
                                value={field.value}
                                onChange={field.onChange}
                                name={name}
                            />
                        </FormControl>
                        <FormMessage />
                    </Card>
                </FormItem>
            )}
        />
    );
};

export default Rating;
